import services from './../services/service'; // Service Class
import validator from './../services/validator'; // Service
import setts from './setts.js'; //varying settings

let service = new services();
let valid = new validator();
export default {
    name: 'Preset',
    mixins: [setts],
    data () {
      return {
        is_logged_in:false,
        user:{},
        logdata:{},
        headerKey: 0,
      }
  },

    methods: {
        // jumpToView(id){
        //     document.getElementById(id).scrollIntoView();
        // },
        set_url(link){
            if((link.includes('http')) || (link.includes('www'))){
                link = link.replace('www','https://www.')
                window.location.href = link;
            }else{
                window.location.href = "https://www."+link;
            }
        },

        set_auto_login() {
            if(Object.keys(this.logdata).length > 0){
                localStorage.setItem("cityneeds_user", this.logdata.user_fullname);
                localStorage.setItem("cityneeds_token", this.logdata.user_session_key); //store session key here linked to session well @server
                localStorage.setItem("cityneeds_token_key", this.logdata.user_token_key); 
            }
        },

        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        this.is_logged_in = true;
                        data.forEach(function(element) {
                           // this.user.user_id = element.user_id;
                            //special case for profile
                            service.getUser(this, element.user_id).then(data => {
                                if(data.body.status == 200) {
                                    this.user = data.body.data;
                                    this.user.user_phone = "0"+this.user.user_phone;
                                    this.user.user_id = element.user_id;
                                    this.user.current_wallet_balance = 0; //ini
                                    //
                                    localStorage.setItem("cityneeds_user", this.user.user_fullname);
                                    //local call functions
                                    this.getWalletBalance();
                                    
                                    //extented calling functions //helping childs
                                    this.getCNinsuranceAccounts();
                                    
                                }
                            }).catch((err) => {
                                if(err) {
                                   // toastr.error('Sorry, could not process information', 'Warning!');
                                }
                            })
                         //../special case for profile
                         }, this);
                    }else {
                       //this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                        //this.$router.push('login');
                    }
                })
            }else {
                //this.$router.push('login');
            }
        },

        //wallet calls
        getWalletBalance() {
            let set_user_id = localStorage.getItem("cityneeds_token_key");
            service.getWalletBalance(this, set_user_id).then(data => {
                if(data.body.status == 200) {
                    this.user.current_wallet_balance = data.body.data_current_wallet_balance;
                    // localStorage.setItem("cityneeds_wb", this.current_wallet_balance);
                    this.headerKey++;
                }
            }).catch((err) => {
                if(err) {
                    ///--REFLOW-----//toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

     
    },
    created: function(){
        this.preset();
    }
}


// WEBPACK FOOTER //
// ./src/mixins/preset.js